import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const PostcoderOptionRecord = Record({
  count: 0,
  id: '',
  locationsummary: '',
  summaryline: '',
});

export default class PostcoderOption extends PostcoderOptionRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined') {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new PostcoderOption(hydrated);
  }
}
